import { getRequest } from '../services/requestHandler';
import { PlayerCollegeLookup } from '../models';

export const getPlayerCollegeLookups = async () => {
  const url = `player/GetPlayerCollegeLookups?activeOnly=true&useCache=true`;
  const response = await getRequest<PlayerCollegeLookup>('GetPlayerCollegeLookups', url);
  return response;
};
